import {
	SimpleSlider,
	FluidSlider,
	FlexibleSlider,
} from '../../../js/src/__utils/sliders';
import GalleryLightbox from '../../../js/src/__page/lightboxGallery';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		SimpleSlider.init();
		FlexibleSlider.init();
		FluidSlider.init();
		GalleryLightbox.init();
	},
	loaded() {},
	resized() {
		GalleryLightbox.refreshSlider();
	},
	scrolled() {},
	keyDown(e) {
		GalleryLightbox.keyDown(e);
	},
	mouseUp() {},
};
export default controller;
